import { useField } from 'formik'

import Error from './error'
import RadioButton from './radio-button'

const FieldRadioButton = ({ name, id, value, ...rest }) => {
  const [field] = useField(name)
  return (
    <RadioButton
      id={id}
      name={name}
      defaultChecked={field.value === value}
      aria-checked={field.value === value}
      {...field}
      {...rest}
      value={value}
      error={<Error name={name} />}
    />
  )
}

export default FieldRadioButton
